<div class="card mb-3">
    <div class="card-header">
        <h5>Personal Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>First Name:</strong> {{seller.firstName}}</p>
                <p><strong>Last Name:</strong> {{seller.lastName}}</p>
            </div>
            <div class="col-md-6">
                <p><strong>Phone:</strong> {{seller.phone || 'N/A'}}</p>
                <p><strong>Email: </strong> {{seller.email || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Identity Document</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <ng-container *ngIf="seller.documents && seller.documents.length > 0">
                    <div *ngFor="let doc of seller.documents" class="mb-2">
                        <p><strong>{{getDocumentTypeLabel(doc.documentType)}}:</strong></p>
                        <button class="btn btn-primary" (click)="downloadDocument(doc.id, doc.documentPath)">
                            Download Document
                        </button>
                    </div>
                </ng-container>
                <ng-template #noDocument>
                    <p class="text-muted mb-0">No documents uploaded</p>
                </ng-template>
                <div *ngIf="!seller.documents || seller.documents.length === 0">
                    <p class="text-muted mb-0">No documents uploaded</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Payment Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Payment Type:</strong> 
                    {{seller.paymentInfo.paymentType === 'MOBILE_MONEY' ? 'Mobile Money' : 'Bank Transfer'}}
                </p>
            </div>
        </div>
        
        <!-- Mobile Money Details -->
        <div *ngIf="seller.paymentInfo.paymentType === 'MOBILE_MONEY'">
            <div class="row">
                <div class="col-md-6">
                    <p><strong>Provider:</strong> {{seller.paymentInfo.mobileMoneyProvider || 'N/A'}}</p>
                    <p><strong>Mobile Number:</strong> {{seller.paymentInfo.mobileMoneyNumber || 'N/A'}}</p>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <p><strong>Verification Status:</strong>
                        <span class="badge" [ngClass]="seller.paymentInfo.numberVerified ? 'bg-success' : 'bg-warning'">
                            {{seller.paymentInfo.numberVerified ? 'Verified' : 'Not Verified'}}
                        </span>
                    </p>
                </div>
            </div>
        </div>
        
        <!-- Bank Details -->
        <div class="row" *ngIf="seller.paymentInfo.paymentType === 'BANK'">
            <div class="col-md-6">
                <p><strong>Bank Name:</strong> {{seller.paymentInfo.bankName || 'N/A'}}</p>
                <p><strong>Account Number:</strong> {{seller.paymentInfo.accountNumber || 'N/A'}}</p>
            </div>
            <div class="col-md-6">
                <p><strong>Account Holder:</strong> {{seller.paymentInfo.accountHolderName || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>
